export default function Disclaimer({ className = "" }) {
  return (
    <p
      data-testid="wellness-disclaimer"
      className={`text-xs font-sans text-[#9B7E8D] leading-relaxed ${className}`}
    >
      This is a self-tracking and educational wellness tool — not a medical
      assessment, diagnosis, or treatment. For clinical care, please book a
      consult with a qualified practitioner.
    </p>
  );
}
